import React from 'react';
import { Helmet } from 'react-helmet';
import CustomWebDevelopment from './CustomWebDevelopment';

const CustomWebDevelopmentPage = () => (
  <>
    <Helmet>
      <title>Custom Web Development | MilaajBrandset</title>
      <meta
        name="description"
        content="Get bespoke web development services with MilaajBrandset, tailored to meet your unique business needs and goals."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, custom web development, bespoke websites, business solutions"
      />
      <meta property="og:title" content="Custom Web Development | MilaajBrandset" />
      <meta
        property="og:description"
        content="Get bespoke web development services with MilaajBrandset, tailored to meet your unique business needs and goals."
      />
    </Helmet>
    <CustomWebDevelopment />
  </>
);

export default CustomWebDevelopmentPage;